import { useEffect, useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar, } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getCoupons } from "../AddCoupons/Coupons.action";
import { getDailyPromoReport } from "./Report.action";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import Swal from "sweetalert";
import moment from "moment";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const DayWisePromoReport = (props) => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [couponsName, setCouponsName] = useState();
  const [couponsId, setCouponsId] = useState();
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went Wrong!",
      icon: "error",
      button: "Ok",
    });
  };
  const exportPDF = () => {
    props.getDailyPromoReport({
      current_date: startDate,
      coupon: couponsId,
    },
      handleDangerVisible,
    );
  };

  const getItem = props.couponsDataList.map((x) => { let data = { value: x._id, label: x.name }; return data });
  const handleChangeLedgerItem = (selectedOption) => {
    setCouponsId(selectedOption.value);
    setCouponsName(selectedOption.label);
  };

  useEffect(() => {
    props.getCoupon();
  }, []);

  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Daily Promo Report</b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>
      {props.isFetchingCouponsData ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="border"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Row>
              <Breadcrumb>
                <Breadcrumb.Item ><Link to="/home">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                <Breadcrumb.Item active>Daily Promo Report</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Form.Label><b>Date *</b></Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  ></Form.Control>
                </FormGroup>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label><b>Selet Coupon *</b></Form.Label>
                  <Select
                    placeholder="Select Coupon"
                    onChange={handleChangeLedgerItem}
                    options={getItem}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {_.isEmpty(startDate) || _.isEmpty(couponsId) ? (
                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
              ) : (
                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
              )}
            </div>

          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDailyPromoReport: (data, handleDangerVisible) => dispatch(getDailyPromoReport(data, handleDangerVisible)),
    getCoupon: () => dispatch(getCoupons()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  couponsDataList: state.CouponReducer.couponsDataList,
  isFetchingCouponsData: state.CouponReducer.isFetchingCouponsData,
  isFetchingPromoReport: state.ReportReducer.isFetchingPromoReport,
  promoReportData: state.ReportReducer.promoReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DayWisePromoReport);
